// @flow

import React from 'react';

import {Alert} from '../../molecules/baseline/baseline';
import translate from '../../../utils/translations';

import './IpmAdditionalInfo.less';
type Props = {
    isBookingModified: boolean,
    translations: Object,
};

export const IpmAdditionalInfo = ({isBookingModified, translations}: Props) => {
    return (
        <Alert
            className="IpmAdditionalInfo"
            subtle
            svgClassName="text-info"
            svgMarkup=""
        >
            {translate(
                translations,
                'trav-dash/trav-home',
                'messages',
                isBookingModified
                    ? 'th.inbox.conversation.ipm.modified.booking.payments.message'
                    : 'th.inbox.conversation.ipm.nonmodified.booking.payments.message'
            )}
        </Alert>
    );
};
